import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import axios from 'axios';
import Sidebar from 'react-sidebar';

import Avatar from '../../common/Avatar';

import FooterMobile from '../common/footer/FooterMobile';
import ProfileTabContentMobile from './tabs/ProfileTabContentMobile';
import PaymentsTabContentMobile from './tabs/PaymentsTabContentMobile';
import CoursesTabContentMobile from './tabs/CoursesTabContentMobile';

import SidebarContent from '../../common/sidebar/SidebarContent';
import MobileHeader from '../common/header/MobileHeader';

import Loader from '../../common/loader/Loader';
import Alert from '../../common/Alert';

import { getMobileSidebarStyles } from '../../../utils/sidebar-utils';
import { checkUserAuth } from '../../../utils/auth-utils';

const tabs = ['Courses', 'Profile', 'Payments'];

const defaultTimetable = [
  { month: 'Sun', times: [] },
  { month: 'Mon', times: [] },
  { month: 'Tue', times: [] },
  { month: 'Wed', times: [] },
  { month: 'Thu', times: [] },
  { month: 'Fri', times: [] },
  { month: 'Sat', times: [] },
];

const defaultWebinar = {
  name: 'Coming soon',
  description: 'We are working to prepare the best webinar for you',
  date: 'Date is undefined',
  price: 0,
};

const ProfilePageMobile = props => {
  const { user, token, isAuthenticated } = useSelector(state => state);

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const [courses, setCourses] = useState([]);
  const [timetable, setTimetable] = useState(defaultTimetable);
  const [payments, setPayments] = useState([]);
  const [webinar, setWebinar] = useState(defaultWebinar);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [status, setStatus] = useState({ isLoading: false, isError: false });

  const toggleSidebarOpen = e => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  const closeSidebar = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    setStatus({ isLoading: true, isError: false });
    axios
      .get('/api/v1/profile', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        setPayments(response.data.payments);
        setCourses(response.data.courses);
        setTimetable(response.data.timetable);

        if (response.data.webinar) {
          setWebinar(response.data.webinar);
        }
        setStatus({ isLoading: false, isError: false });
      })
      .catch(e => {
        setStatus({ isLoading: false, isError: true });
        checkUserAuth(e, props.history);
      });
  }, []);

  const changeTab = index => e => {
    e.preventDefault();
    setActiveTabIndex(index);
  };

  return (
    <Sidebar
      open={isMenuOpen}
      onSetOpen={setIsMenuOpen}
      sidebar={<SidebarContent closeSidebar={closeSidebar} />}
      styles={getMobileSidebarStyles()}
    >
      <MobileHeader isAuthenticated={isAuthenticated} toggleSidebarOpen={toggleSidebarOpen} />
      <Loader isVisible={status.isLoading} />
      <div className="m-container">
        <div className="m-profile-header">
          {status.isError && <Alert isSmall isError message="An error occured" />}
          <div className="is-flex align-items-center py-15px">
            <Avatar />
            <p className="ml-10px">{user.name}</p>
          </div>
        </div>
      </div>
      <div className="is-fullwidth is-flex">
        {tabs.map((tab, tabIndex) => {
          return (
            <a
              key={tab}
              className={classnames('m-profile-tab', { active: tabIndex === activeTabIndex })}
              style={{ width: `${100 / tabs.length}%` }}
              onClick={changeTab(tabIndex)}
            >
              {tab}
            </a>
          );
        })}
      </div>
      <div className="m-profile-tab-content p">
        {activeTabIndex === 0 && <CoursesTabContentMobile courses={courses} webinar={webinar} timetable={timetable} />}
        {activeTabIndex === 1 && <ProfileTabContentMobile />}
        {activeTabIndex === 2 && <PaymentsTabContentMobile payments={payments} />}
      </div>
      <FooterMobile />
    </Sidebar>
  );
};

ProfilePageMobile.propTypes = {
  history: PropTypes.object.isRequired,
};

export default ProfilePageMobile;
